import { Controller } from "@hotwired/stimulus"

// Companion controller for the autocomplete on the whitelist add form.
// When an autocomplete result is selected (format: "Artist: Name" or "Label: Name"),
// this controller looks up the actual record ID via the search endpoint and
// populates the hidden form fields.
export default class WhitelistAddController extends Controller {
  static targets = ["searchInput", "form", "itemType", "itemId", "selectedDisplay", "selectedName"]
  static values = { searchUrl: String }

  connect() {
    this.boundOnSelect = this.onSelect.bind(this)
    this.element.addEventListener("autocomplete.change", this.boundOnSelect)
  }

  disconnect() {
    if (this.boundOnSelect) {
      this.element.removeEventListener("autocomplete.change", this.boundOnSelect)
      this.boundOnSelect = null
    }
  }

  onSelect(event) {
    const textValue = event.detail.textValue
    const match = textValue.match(/^(Artist|Label):\s*(.+)$/)
    if (!match) return

    const typeLabel = match[1]
    const name = match[2].trim()
    const itemType = typeLabel === 'Label' ? 'RecordLabel' : 'Artist'

    // Look up the ID via the search endpoint
    const url = new URL(this.searchUrlValue, window.location.origin)
    url.searchParams.set('q', name)
    url.searchParams.set('type', itemType)
    url.searchParams.set('exact', '1')

    fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data.id) {
          this.itemTypeTarget.value = itemType
          this.itemIdTarget.value = data.id
          this.selectedNameTarget.textContent = textValue
          this.selectedDisplayTarget.style.display = ''
          this.searchInputTarget.style.display = 'none'
        }
      })
  }

  clear(event) {
    event.preventDefault()
    this.itemTypeTarget.value = ''
    this.itemIdTarget.value = ''
    this.selectedDisplayTarget.style.display = 'none'
    this.searchInputTarget.style.display = ''
    this.searchInputTarget.value = ''
    this.searchInputTarget.focus()
  }
}
